// Client/trusted-leaders marquee hidden pending logo approval: restore below when cleared.
// import React from 'react';
// import LogoMarquee from '../shared/LogoMarquee';
// import { COMPANY_LOGOS } from '../../../content/logoSlideshowData';

const LogoSlideshow = () => {
  // Temporary: hide entire company logo section until approval.
  return null;

  /*
  return (
    <div className="w-full border-t border-ink-200/60 py-10">
      <div className="mx-auto mb-6 max-w-3xl px-6 text-center lg:px-8">
        <p className="eyebrow">Trusted by industry leaders</p>
        <h3 className="mt-2 text-xl font-semibold tracking-tight text-ink-900 sm:text-2xl">
          Teams at enterprise organizations rely on our work.
        </h3>
      </div>
      <div
        className="w-full py-3"
        style={{ background: 'rgba(240,250,255,0.6)' }}
      >
        <LogoMarquee
          logos={COMPANY_LOGOS}
          direction="left"
          duration={55}
        />
      </div>
    </div>
  );
  */
};

export default LogoSlideshow;
